import { useQuery } from "@apollo/client";
import { BaseTable, IBaseTableProps } from "@sede-x/shell-ds-react-framework";
import { getPaginationRowModel } from "@tanstack/react-table";
import { loader } from "graphql.macro";
import { useState } from "react";
import { ApolloErrorViewer } from "shared/components/ApolloErrorViewer";
import LoadingPanel from "shared/components/LoadingPanel";
import { GqlResponse, TPnlDetailsOfMovementAtRevision } from "ticketing/ticketing.types";
import { equalsIgnoreCase } from "ticketing/utils";

type Response = GqlResponse<
  TPnlDetailsOfMovementAtRevision[],
  "pnlDetailsOfMovementAtRevision"
>;
const GET_PNL_DETAILS_REVISIONS_OF_MOVEMENT = loader(
  "../../ticketing-graphql/pnlDetailsOfMovementAtRevision.graphql"
);

type RevisionsMovementPnlDetailsProps = {
  movementId: string;
  revisionNumber: string;
};

const columns: IBaseTableProps<TPnlDetailsOfMovementAtRevision>["columns"] = [
  {
    header: "Name",
    accessorKey: "name",
    size: 200
  },
  {
    header: "Value",
    accessorKey: "value",
    size: 260
  }
];

const RevisionsMovementPnlDetails = ({
  movementId,
  revisionNumber
}: RevisionsMovementPnlDetailsProps) => {
  const { loading, error } = useQuery<Response>(GET_PNL_DETAILS_REVISIONS_OF_MOVEMENT, {
    fetchPolicy: "no-cache",
    variables: { movementId, revisionNumber },
    onCompleted: data =>
      setPnlDetails(
        data.pnlDetailsOfMovementAtRevision.map(d =>
          equalsIgnoreCase(d.name, "pnl_impact") ? { ...d, value: `$${d.value}` } : d
        )
      )
  });
  const [pnlDetails, setPnlDetails] = useState<TPnlDetailsOfMovementAtRevision[]>([]);

  return (
    <>
      {loading && <LoadingPanel />}
      {error && <ApolloErrorViewer error={error} />}
      <BaseTable
        tableOptions={{
          defaultColumn: {
            minSize: 100
          },
          enableColumnResizing: true,
          columnResizeMode: "onChange",
          getPaginationRowModel: getPaginationRowModel()
        }}
        data={pnlDetails}
        columns={columns}
        style={{ width: "100%", tableLayout: "fixed" }}
      />
    </>
  );
};

export default RevisionsMovementPnlDetails;
